var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.198,
    height: 17.202,
    viewBox: "0 0 17.198 17.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram_1_",
    "data-name": "instagram (1)",
    transform: "translate(-0.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M17.6,5.057a6.285,6.285,0,0,0-.4-2.087A4.406,4.406,0,0,0,14.687.454,6.3,6.3,0,0,0,12.6.054C11.679.01,11.387,0,9.052,0S6.424.01,5.507.05A6.287,6.287,0,0,0,3.42.45a4.2,4.2,0,0,0-1.526.995A4.235,4.235,0,0,0,.9,2.967,6.3,6.3,0,0,0,.5,5.054C.459,5.975.449,6.267.449,8.6s.01,2.628.05,3.545a6.285,6.285,0,0,0,.4,2.087,4.406,4.406,0,0,0,2.517,2.517,6.3,6.3,0,0,0,2.087.4c.917.04,1.21.05,3.545.05s2.628-.01,3.545-.05a6.284,6.284,0,0,0,2.087-.4A4.4,4.4,0,0,0,17.2,14.234a6.307,6.307,0,0,0,.4-2.087c.04-.917.05-1.21.05-3.545S17.644,5.975,17.6,5.057ZM16.055,12.08a4.715,4.715,0,0,1-.3,1.6,2.853,2.853,0,0,1-1.633,1.633,4.732,4.732,0,0,1-1.6.3c-.907.04-1.179.05-3.475.05s-2.571-.01-3.475-.05a4.712,4.712,0,0,1-1.6-.3A2.647,2.647,0,0,1,3,14.668a2.674,2.674,0,0,1-.642-.988,4.732,4.732,0,0,1-.3-1.6c-.04-.907-.05-1.18-.05-3.475s.01-2.571.05-3.475a4.712,4.712,0,0,1,.3-1.6A2.615,2.615,0,0,1,3,2.55a2.67,2.67,0,0,1,.988-.642,4.735,4.735,0,0,1,1.6-.3c.907-.04,1.18-.05,3.475-.05s2.571.01,3.475.05a4.715,4.715,0,0,1,1.6.3,2.645,2.645,0,0,1,.988.642,2.674,2.674,0,0,1,.642.988,4.734,4.734,0,0,1,.3,1.6c.04.907.05,1.179.05,3.475S16.1,11.173,16.055,12.08Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M129.368,124.5a4.419,4.419,0,1,0,4.419,4.419A4.42,4.42,0,0,0,129.368,124.5Zm0,7.285a2.866,2.866,0,1,1,2.866-2.866A2.867,2.867,0,0,1,129.368,131.785Zm0,0",
    transform: "translate(-120.316 -120.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M364.513,89.633a1.032,1.032,0,1,1-1.032-1.032A1.032,1.032,0,0,1,364.513,89.633Zm0,0",
    transform: "translate(-349.836 -85.624)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cbcf4bf1e9911169c60ab1fa1a5b54f8.svg";
export { ForwardRef as ReactComponent };